import { Box, Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import AttachedItem from './attachedItem';

import deleteIcon from '../../../../../assets/svg/deleteFolderIconRed.svg';
import { AttachmentList } from '../../../../../interfaces/AttachmentObject';
import { setAttachmentsEmptyFlag } from '../../../../../slices/piiRemovalSlice';
import { RootState } from '../../../../../utils/store';

interface AttachementTabProps {
  attachments: AttachmentList[];
  downloadAttachmentsFlag?: boolean;
  onlyViewFlag?: boolean;
}

const AttachmentTab = ({
  attachments,
  downloadAttachmentsFlag,
}: AttachementTabProps) => {
  const WHISTLEBLOWER_TYPE = 1;
  const IS_RECORDING = 1;
  const whistleblowerAttachments = attachments.filter((attachment) =>
    attachment.files.some(
      (file) => file.userType === WHISTLEBLOWER_TYPE || file.userType === null,
    ),
  );
  const removeAllAttachmentsFlag = useSelector(
    (state: RootState) => state.piiRemoval.removeAllAttachmentsFlag,
  );
  const dispatch = useDispatch();

  dispatch(
    setAttachmentsEmptyFlag(
      whistleblowerAttachments.length === 0 ? true : false,
    ),
  );

  return (
    <Box position='relative' sx={{ width: '100%', height: '100%' }}>
      {whistleblowerAttachments?.map((item, attachmentIndex) => {
        return (
          <>
            {removeAllAttachmentsFlag === true ? (
              <>
                <Grid
                  key={attachmentIndex}
                  container
                  spacing={2}
                  sx={{
                    paddingTop: 3,
                    paddingBottom: 3,
                    scrollbarWidth: 'thin',
                    '::-webkit-scrollbar': {
                      width: '10px',
                    },
                    '::-webkit-scrollbar-track': {
                      background: 'transparent',
                    },
                    '::-webkit-scrollbar-thumb': {
                      bgcolor: 'rgba(155, 155, 155, 0.5)',
                      borderRadius: ' 20px',
                      border: ' transparent',
                    },
                  }}
                >
                  {item.files.map((file, key) => {
                    if (file.attachmentType === IS_RECORDING) {
                      return <></>;
                    }
                    return (
                      <Grid item xs={2} key={key}>
                        <AttachedItem
                          {...file}
                          downloadAttachmentsFlag={downloadAttachmentsFlag}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '5px',
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  }}
                >
                  <Box
                    sx={{
                      width: '292px',
                      height: '88px',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      justifyContent: 'center', // Center horizontally
                      alignItems: 'center', // Center vertically
                      display: 'flex',
                      borderRadius: '6px',
                    }}
                  >
                    <Stack
                      sx={{
                        justifyContent: 'center', // Center horizontally
                        alignItems: 'center', // Center vertically
                        display: 'flex',
                      }}
                    >
                      <img
                        src={deleteIcon}
                        alt='delete-folder-icon'
                        style={{ width: '32px', height: '32px' }}
                      />
                      <Typography
                        sx={{
                          color: 'red',
                          textTransform: 'none',
                          fontSize: '16px',
                          fontFamily: 'Schibsted Grotesk',
                        }}
                      >
                        <FormattedMessage defaultMessage='All attachments are to be removed.' />
                      </Typography>
                    </Stack>
                  </Box>
                </Box>
              </>
            ) : (
              <Grid
                key={attachmentIndex}
                container
                spacing={2}
                sx={{
                  paddingTop: 3,
                  paddingBottom: 3,
                  scrollbarWidth: 'thin',
                  '::-webkit-scrollbar': {
                    width: '10px',
                  },
                  '::-webkit-scrollbar-track': {
                    background: 'transparent',
                  },
                  '::-webkit-scrollbar-thumb': {
                    bgcolor: 'rgba(155, 155, 155, 0.5)',
                    borderRadius: ' 20px',
                    border: ' transparent',
                  },
                }}
              >
                {item.files.map((file, key) => {
                  if (file.attachmentType === IS_RECORDING) {
                    return <></>;
                  }
                  return (
                    <Grid item xs={2} key={key}>
                      <AttachedItem
                        {...file}
                        downloadAttachmentsFlag={downloadAttachmentsFlag}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </>
        );
      })}
    </Box>
  );
};

export default AttachmentTab;
